'use strict';

angular.module('webAgro1App').factory('UsagesService', function($http) {
  return {
    all: function(params) {
      params = {
        usuario: (params.usuario || {}).id
      };

      const url = `${SERVER}${API_VERSION}/usages`;
      return $http.get(url, { params });
    }
  };
});
